import React, { useState, useEffect, useRef } from "react";
export default function ProcessSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  const steps = [{
    number: "01",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>,
    title: "Discovery",
    description: "We learn about your business, goals, target customers, and competitors to build a strategy that works."
  }, {
    number: "02",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path><circle cx="12" cy="12" r="3"></circle></svg>,
    title: "Strategy",
    description: "We develop a custom website and marketing plan tailored to your specific business needs and goals."
  }, {
    number: "03",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect width="20" height="14" x="2" y="3" rx="2"></rect><line x1="8" x2="16" y1="21" y2="21"></line><line x1="12" x2="12" y1="17" y2="21"></line></svg>,
    title: "Build & Optimize",
    description: "Design, development, SEO setup, and conversion optimization — all built to drive real results."
  }, {
    number: "04",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>,
    title: "Launch & Grow",
    description: "We track results, refine the strategy, and continue improving performance long after launch."
  }];
  return <section style={{
    backgroundColor: "rgb(255, 255, 255)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(2, 8, 23)",
    fontFamily: '"DM Sans", sans-serif',
    animation: "none 0s ease 0s 1 normal none running"
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700&family=DM+Sans:wght@400;500;600&display=swap');
        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(24px); }
          100% { opacity: 1; transform: translateY(0px); }
        }
        .process-step-animate {
          opacity: 0;
          transform: translateY(24px);
          transition: opacity 0.6s ease, transform 0.6s ease;
        }
        .process-step-animate.visible {
          opacity: 1;
          transform: translateY(0px);
        }
        .gradient-circle-border {
          background: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          width: 80px;
          height: 80px;
          flex-shrink: 0;
        }
        .gradient-circle-border::before {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 50%;
          padding: 2.5px;
          background: linear-gradient(135deg, #2563EB 0%, #06B6D4 100%);
          -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
        }
        .connector-line {
          flex: 1;
          height: 1.5px;
          background: linear-gradient(90deg, #2DD4BF 0%, #06B6D4 100%);
          opacity: 0.5;
          margin-bottom: 0;
          align-self: center;
          position: relative;
          top: -1px;
        }
        .process-link:hover {
          color: #1d4ed8;
        }
        .process-link:hover .process-link-arrow {
          transform: translateX(3px);
        }
        .process-link-arrow {
          transition: transform 0.2s ease;
        }
      `}</style>

      <div className="py-20 md:py-28" style={{
      paddingTop: undefined,
      paddingBottom: undefined
    }}>
        <div className="page-container" style={{
        paddingTop: "0",
        paddingBottom: "0"
      }}>
          <div style={{
          paddingTop: "112px",
          paddingBottom: "112px"
        }} className="hidden md:block" />
        </div>
      </div>

      <div style={{
      paddingTop: "80px",
      paddingBottom: "80px"
    }} className="md:hidden">
        <Inner steps={steps} visible={visible} refProp={ref} />
      </div>

      <div style={{
      paddingTop: "112px",
      paddingBottom: "112px"
    }} className="hidden md:block">
        <Inner steps={steps} visible={visible} refProp={ref} />
      </div>
    </section>;
}
function Inner({
  steps,
  visible,
  refProp
}: {
  steps: {
    number: string;
    icon: React.ReactNode;
    title: string;
    description: string;
  }[];
  visible: boolean;
  refProp: React.RefObject<HTMLDivElement>;
}) {
  return <div className="page-container" ref={refProp}>
      <div className="flex flex-col items-center text-center">
        <div className={`process-step-animate${visible ? " visible" : ""} inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full mb-5`} style={{
        backgroundColor: "#F1F5F9",
        transitionDelay: "0ms"
      }}>
          <span style={{
          color: "#64748B",
          display: "flex",
          alignItems: "center"
        }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M12 6v6l4 2"></path></svg>
          </span>
          <span style={{
          color: "#64748B",
          fontFamily: '"DM Sans", sans-serif',
          fontSize: "13px",
          fontWeight: 500
        }}>
            Our Process
          </span>
        </div>

        <h2 className={`process-step-animate${visible ? " visible" : ""} mb-4`} style={{
        color: "rgb(30, 41, 59)",
        fontFamily: "Outfit, sans-serif",
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        letterSpacing: "-1.2px",
        border: "0px solid rgb(226, 232, 240)",
        textAlign: "center",
        animation: "none 0s ease 0s 1 normal none running",
        transitionDelay: "80ms"
      }}>
          A Proven Path to{" "}
          <span style={{
          color: "#2563EB"
        }}>Online</span>{" "}
          <span style={{
          color: "#06B6D4"
        }}>Growth</span>
        </h2>

        <p className={`process-step-animate${visible ? " visible" : ""} max-w-xl`} style={{
        color: "rgb(100, 116, 139)",
        fontFamily: '"DM Sans", sans-serif',
        fontSize: "18px",
        fontWeight: "400",
        lineHeight: "29.25px",
        border: "0px solid rgb(226, 232, 240)",
        textAlign: "center",
        animation: "none 0s ease 0s 1 normal none running",
        transitionDelay: "160ms",
        marginBottom: "56px"
      }}>
          We&apos;ve refined our process over years of helping local businesses succeed online.
          <br />
          Here&apos;s how we&apos;ll work together.
        </p>

        <div className="w-full">
          <div className="flex flex-col md:flex-row items-start justify-between w-full gap-8 md:gap-0 relative">
            {steps.map((step, i) => <div key={step.number} className="flex flex-col items-center flex-1 relative">
                {i < steps.length - 1 && <div className="hidden md:block connector-line absolute" style={{
              left: "calc(50% + 40px)",
              right: "calc(-50% + 40px)",
              top: "40px",
              height: "1.5px",
              zIndex: 0
            }} />}

                <div className={`process-step-animate${visible ? " visible" : ""} gradient-circle-border mb-4`} style={{
              transitionDelay: `${200 + i * 100}ms`,
              zIndex: 1
            }}>
                  <span style={{
                fontFamily: "Outfit, sans-serif",
                fontSize: "22px",
                fontWeight: "700",
                color: "#2563EB",
                lineHeight: 1
              }}>
                    {step.number}
                  </span>
                </div>

                <div className={`process-step-animate${visible ? " visible" : ""} flex items-center justify-center mb-3`} style={{
              width: "36px",
              height: "36px",
              borderRadius: "8px",
              backgroundColor: "#EFF6FF",
              color: "#2563EB",
              transitionDelay: `${260 + i * 100}ms`,
              flexShrink: 0
            }}>
                  <span style={{
                display: "flex",
                width: "20px",
                height: "20px",
                color: "#2563EB"
              }}>
                    {step.icon}
                  </span>
                </div>

                <h3 className={`process-step-animate${visible ? " visible" : ""} mb-2`} style={{
              color: "rgb(30, 41, 59)",
              fontFamily: "Outfit, sans-serif",
              fontSize: "20px",
              fontWeight: "600",
              lineHeight: "28px",
              border: "0px solid rgb(226, 232, 240)",
              textAlign: "center",
              animation: "none 0s ease 0s 1 normal none running",
              transitionDelay: `${300 + i * 100}ms`
            }}>
                  {step.title}
                </h3>

                <p className={`process-step-animate${visible ? " visible" : ""} max-w-xs`} style={{
              color: "rgb(100, 116, 139)",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "22.75px",
              border: "0px solid rgb(226, 232, 240)",
              textAlign: "center",
              animation: "none 0s ease 0s 1 normal none running",
              transitionDelay: `${340 + i * 100}ms`
            }}>
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>

        <div className={`process-step-animate${visible ? " visible" : ""} mt-12 flex items-center justify-center`} style={{
        transitionDelay: "700ms"
      }}>
          <a href="#" className="process-link inline-flex items-center gap-1.5 transition-colors duration-150" style={{
          color: "rgb(37, 99, 235)",
          fontFamily: '"DM Sans", sans-serif',
          fontSize: "14px",
          fontWeight: "600",
          lineHeight: "20px",
          border: "0px solid rgb(226, 232, 240)",
          textAlign: "center",
          animation: "none 0s ease 0s 1 normal none running",
          textDecoration: "none"
        }}>
            Learn more about our process
            <span className="process-link-arrow" style={{
            display: "flex",
            alignItems: "center",
            width: "16px",
            height: "16px"
          }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>
            </span>
          </a>
        </div>
      </div>
    </div>;
}